import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTooltipContext } from './tooltip/hook';
import { TooltipContext } from './tooltip';
import { usePhantomContext } from './phantom/hooks';
import { PhantomContext } from './phantom';
import { useGlobalContext } from './global/hooks';
import { GlobalContext } from './global';
export default function ContextProvider(_a) {
    var children = _a.children;
    var tooltipContextValue = useTooltipContext();
    var globalContextValue = useGlobalContext();
    var phantomContextValue = usePhantomContext({
        setLoading: globalContextValue.setLoading,
        setLoadingText: globalContextValue.setLoadingText,
    });
    return (_jsx(GlobalContext.Provider, { value: globalContextValue, children: _jsx(PhantomContext.Provider, { value: phantomContextValue, children: _jsx(TooltipContext.Provider, { value: tooltipContextValue, children: children }) }) }));
}
